var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.itemId)?_c('FieldHistoryButton',{staticClass:"ms-2",attrs:{"model-name":_vm.ctx.modelName,"item-id":_vm.itemId,"field-path":_vm.field.key,"field":_vm.field}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }